export default __webpack_public_path__ + "static/media/button-share.7aeddb37.svg";